import { render, staticRenderFns } from "./central.vue?vue&type=template&id=03ae403b&"
import script from "./central.vue?vue&type=script&lang=js&"
export * from "./central.vue?vue&type=script&lang=js&"
import style0 from "./central.vue?vue&type=style&index=0&id=03ae403b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports